import(/* webpackMode: "eager" */ "/codebuild/output/src783933424/src/github.com/bitstone/offerz-nextjs/src/app/[lang]/(main)/not-found.tsx");
